import { render, staticRenderFns } from "./AdobeXdIcon.vue?vue&type=template&id=54b1b03e"
import script from "./AdobeXdIcon.vue?vue&type=script&lang=js"
export * from "./AdobeXdIcon.vue?vue&type=script&lang=js"
import style0 from "./AdobeXdIcon.vue?vue&type=style&index=0&id=54b1b03e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports